module.exports = __webpack_public_path__ + "img/center-info-structure4.e6e8a678.png";